"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Check = void 0;

var _taggedTemplateLiteral2 = _interopRequireDefault(require("@babel/runtime/helpers/taggedTemplateLiteral"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _palette = require("../../../styles/palette");

var _widths = require("../../../styles/widths");

var _templateObject;

var Check = _styledComponents["default"].span(_templateObject || (_templateObject = (0, _taggedTemplateLiteral2["default"])(["\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  height: 16px;\n  width: 16px;\n  background-color: ", ";\n  border-radius: 50%;\n  border: solid 2px ", ";\n  margin-right: ", "px;\n  &:after {\n    width: 8px;\n    height: 8px;\n    border-radius: 50%;\n    background: ", ";\n    content: \"\";\n    display: ", ";\n  }\n"])), _palette.palette.white, function (props) {
  return props.checked ? props.color : _palette.palette.grey;
}, _widths.widths.base, function (props) {
  return props.color;
}, function (props) {
  return props.checked ? 'block' : 'none';
});

exports.Check = Check;
Check.displayName = 'Check';